// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"UPSearchBar--searchInput--16CZH","highlightYellowFadeIn":"UPSearchBar--highlightYellowFadeIn--2nAxI"};